// extracted by mini-css-extract-plugin
export default {"header":"Header_header__r36jx","main-image":"Header_main-image__s1CmY"};